module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.exit
    }
  }, [_c('v-icon', [_vm._v("clear")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Edit Profile")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "blue"
    },
    on: {
      "click": _vm.saveUser
    }
  }, [_vm._v("Save")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "input",
      "label": "Name",
      "required": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.user.name),
      callback: function($$v) {
        _vm.$set(_vm.user, "name", $$v)
      },
      expression: "user.name"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "input",
      "label": "Username",
      "rules": [_vm.emailRule],
      "required": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.user.username),
      callback: function($$v) {
        _vm.$set(_vm.user, "username", $$v)
      },
      expression: "user.username"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.roles,
      "item-text": "name",
      "item-value": "id",
      "multiple": "",
      "chips": "",
      "label": "User Roles",
      "disabled": ""
    },
    model: {
      value: (_vm.user.roles),
      callback: function($$v) {
        _vm.$set(_vm.user, "roles", $$v)
      },
      expression: "user.roles"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "input",
      "label": "New Password",
      "required": "",
      "rules": [_vm.passwordRule, _vm.passwordsEqual],
      "type": "password",
      "counter": "",
      "min": _vm.passwordLength
    },
    model: {
      value: (_vm.passwordReset1),
      callback: function($$v) {
        _vm.passwordReset1 = $$v
      },
      expression: "passwordReset1"
    }
  }, [_vm._v("\n        >")])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "input",
      "label": "Verify New Password",
      "required": "",
      "rules": [_vm.passwordRule, _vm.passwordsEqual],
      "type": "password",
      "counter": "",
      "min": _vm.passwordLength
    },
    model: {
      value: (_vm.passwordReset2),
      callback: function($$v) {
        _vm.passwordReset2 = $$v
      },
      expression: "passwordReset2"
    }
  }, [_vm._v("\n        >")])], 1), _vm._v(" "), _c('v-col', [_c('v-switch', {
    attrs: {
      "hint": "",
      "inset": "",
      "label": "Night Theme",
      "persistent-hint": ""
    },
    on: {
      "click": _vm.themeToggle
    },
    model: {
      value: (_vm.theme),
      callback: function($$v) {
        _vm.theme = $$v
      },
      expression: "theme"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('error-snackbar', {
    model: {
      value: (_vm.errorText),
      callback: function($$v) {
        _vm.errorText = $$v
      },
      expression: "errorText"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5021a386","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserMe.vue
// module id = 428
// module chunks = 1